module.exports = __webpack_public_path__ + "static/img/air-freight-right.ea87508d.jpg";